export default __webpack_public_path__ + "static/media/sample_2.600244d1.png";